(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-defined.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-defined.js');

'use strict';

const {
  clx
} = svs.components.lbUtils;
const {
  CompetitionLogo,
  LoginButton,
  Registration
} = svs.components.marketplaceCompetition.overviewHero.common;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const {
  IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET
} = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState;
const UserNotLoggedIn = _ref => {
  let {
    competition,
    compName
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Var med och sl\xE5ss om titeln")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let {
    competition,
    compName
  } = _ref2;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Anm\xE4l dig till t\xE4vlingen")), React.createElement(Registration, {
    competition: competition
  })));
};
const UserHasNoBet = _ref3 => {
  let {
    competition,
    compName
  } = _ref3;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "F\xF6rsta omg\xE5ngen \xF6ppnar snart f\xF6r spel."))));
};
const UserHasBet = _ref4 => {
  let {
    competition,
    compName
  } = _ref4;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName)))));
};
const CompetitionOpenDrawDefined = _ref5 => {
  let {
    competition,
    userState
  } = _ref5;
  const compName = resolveCompetitionName(competition);
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition,
          compName: compName
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition,
          compName: compName
        });
    }
  };
  return React.createElement("div", {
    className: clx('competition-overview-hero competition-open-draw-defined', userState)
  }, renderContentBasedOnUserState(userState));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionOpenDrawDefined', CompetitionOpenDrawDefined);

 })(window);